import { render, staticRenderFns } from "./user-confirmation-modal.vue?vue&type=template&id=280084bc&scoped=true&"
import script from "./user-confirmation-modal.vue?vue&type=script&lang=js&"
export * from "./user-confirmation-modal.vue?vue&type=script&lang=js&"
import style0 from "./user-confirmation-modal.vue?vue&type=style&index=0&id=280084bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280084bc",
  null
  
)

component.options.__file = "user-confirmation-modal.vue"
export default component.exports